module.exports = __webpack_public_path__ + "static/img/1468276.ecc616d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/character/1468276.png
// module id = lE7g
// module chunks = 3